$(document).ready(function() {
    $(".element-related-pages .card-with-image").click(function() {
        var href = $(this).attr('data-link');

        if (href) {
            window.location = href;
        }

        return false;
    });
});


// WEBPACK FOOTER //
// ./javascript/src/elementrelatedpages.js